import type { FieldSchema } from '../../types';
import type { Group } from '../../models/Group';
import { useFormField } from '../../hooks/useFormField';
import { QuestionWrapper } from '../QuestionWrapper';

export interface FieldProps {
  fieldSchema: FieldSchema;
  group: Group;
}

export function TextField({ fieldSchema, group }: FieldProps) {
  const field = useFormField(fieldSchema, group);
  const maxLength = fieldSchema.maxLength ?? 150;

  return (
    <QuestionWrapper {...field} fieldSchema={fieldSchema}>
      <div className="answer-group">
        <div className="answer">
          <input
            type="text"
            className="text"
            maxLength={maxLength}
            value={String(field.answer ?? '')}
            onChange={(e) => field.setAnswer(e.target.value)}
            name={field.question.id}
            id={`input-${field.question.id}`}
          />
        </div>
      </div>
    </QuestionWrapper>
  );
}
